import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { GA_ATRIBUTES, DataAttribute } from '@/shared/constants/GoogleAnalytics';
export const useGoogleAnalytics = () => {
  const { t } = useI18n();

  const DEFAULT_VALUES = {
    [GA_ATRIBUTES.TYPE]: t('eventTrackingtype'),
    [GA_ATRIBUTES.CATEGORY]: t('eventCategoryActionsOnProfilePages'),
    [GA_ATRIBUTES.ACTION]: '',
  };

  const dataAttributesGA = ref<DataAttribute>(DEFAULT_VALUES);

  const updateAttributeGA = (
    updateValues: Pick<DataAttribute, GA_ATRIBUTES.CATEGORY | GA_ATRIBUTES.ACTION | GA_ATRIBUTES.LABEL>
  ) => {
    dataAttributesGA.value = { ...DEFAULT_VALUES, ...updateValues };
  };

  return { updateAttributeGA, dataAttributesGA };
};
